export default __webpack_public_path__ + "static/media/openPay.77b290c0.png";